import {VideoPlayer} from './VideoPlayer';

export * from './types';
export default VideoPlayer;
